export default class CookieUtils {
    /**
     * @param {string} name
     * @return {string|null} returns null if cookie isn't found, otherwise the cookie value
     */
    static getCookie(name) {
        const cookies = document.cookie.split(';');
        // Iterate all cookies
        while (cookies.length) {
            const cookie = cookies.pop();
            if (!cookie) {
                continue;
            }
            // Determine separator index ("name=value")
            let separatorIndex = cookie.indexOf('=');
            // IE<11 omits the equal sign when the cookie value is empty
            separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
            const cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
            // Return cookie value if the name matches
            if (cookie_name === name) {
                return decodeURIComponent(cookie.slice(separatorIndex + 1));
            }
        }
        // Return `null` as the cookie was not found
        return null;
    }
}
//# sourceMappingURL=CookieUtils.js.map